import { render, staticRenderFns } from "./TransferAgreement.vue?vue&type=template&id=7938d5f6&scoped=true&"
import script from "./TransferAgreement.vue?vue&type=script&lang=js&"
export * from "./TransferAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TransferAgreement.vue?vue&type=style&index=0&id=7938d5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938d5f6",
  null
  
)

/* custom blocks */
import block0 from "./TransferAgreement.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports